import React, { useState } from "react";
import { Combobox as NDSCombobox } from "@narmi/design_system";

const Combobox = (props: any) => {
  const initialValue =
    props.children.find((child: React.ReactElement<any>) => props.value === child?.props?.value)
      ?.props?.searchValue || "";
  const [defaultInputValue, setDefaultInputValue] = useState<string>(initialValue);
  const defaultFilterItemsByInput = (items: React.ReactElement<any>[], inputValue: string) =>
    items.filter((item) => {
      const query = item.props.searchValue || item.props.value;
      try {
        return query.match(new RegExp(inputValue, "i"));
      } catch {
        return false;
      }
    });
  return (
    <NDSCombobox
      inputValue={props.inputValue || defaultInputValue}
      onInputChange={(updatedValue: string) => {
        if (props.onInputChange) {
          props.onInputChange(updatedValue);
          return;
        }
        setDefaultInputValue(updatedValue);
      }}
      filterItemsByInput={props.filterItemsByInput || defaultFilterItemsByInput}
      {...props}
    />
  );
};

Combobox.Item = NDSCombobox.Item;
Combobox.Action = NDSCombobox.Action;
Combobox.Category = NDSCombobox.Category;
Combobox.Heading = NDSCombobox.Heading;
export default Combobox;
